module.exports = __webpack_public_path__ + "img/no-room-icon.23f52212.png";